async function editUserPhone(newPhone: String): Promise<number> {
  try {
      const url = `https://ruuf-backend.online/user`;
      const timeout = new Promise<Response>((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000),
      );
      const response = await Promise.race([
        fetch(url, {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ phone: newPhone }),
        }),
        timeout,
      ]);

      if (!(response instanceof Response)) {
        throw response;
      }
      if (response.status === 200) {
        console.log("Phone changed succesfully: ", newPhone);
        return 1;
      } else {
        throw new Error("Could not Change Phone");
      }
    } catch (error) {
      console.error("Error changing Phone:", error);
      return 0;
    }
}

export default editUserPhone;